import {
  normalizeProductSku,
  ProductStatus,
  productToFirestore,
} from '@parallel-fluidics/shared/models/products';
import {
  collection,
  doc,
  getDocs,
  getFirestore,
  limit,
  query,
  runTransaction,
  serverTimestamp,
  where,
} from 'firebase/firestore';

export default async function updateProduct(productDocId, values) {
  const db = getFirestore();
  const productRef = doc(db, 'products', productDocId);
  const normalizedSku = normalizeProductSku(values.sku);

  await runTransaction(db, async (transaction) => {
    const productSnapshot = await transaction.get(productRef);

    if (!productSnapshot.exists()) {
      throw new Error(`Product not found: ${productDocId}`);
    }

    const currentData = productSnapshot.data();

    if (values.status === ProductStatus.ACTIVE && !currentData.activeVersionId) {
      throw new Error('Cannot activate a product without an active version');
    }

    if (currentData.activeVersionId && normalizedSku !== currentData.sku) {
      throw new Error('SKU cannot be changed after a version has been activated');
    }

    if (normalizedSku !== currentData.sku) {
      const skuCheck = await getDocs(query(
        collection(db, 'products'),
        where('sku', '==', normalizedSku),
        limit(1),
      ));
      if (!skuCheck.empty) {
        throw new Error(`SKU already exists: ${normalizedSku}`);
      }
    }

    transaction.set(productRef, productToFirestore({
      ...currentData,
      sku: normalizedSku,
      name: values.name?.trim(),
      description: values.description?.trim() || null,
      status: values.status,
      activeVersionId: currentData.activeVersionId || null,
      labelQrHeader: values.labelQrHeader?.trim() || null,
      labelQrUrl: values.labelQrUrl?.trim() || null,
      createdAt: currentData.createdAt,
    }, serverTimestamp));
  });

  return productDocId;
}
